import React from 'react';

const PersonCycleIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
    <g clipPath='url(#a)'>
      <path
        d='M16.125 16c3.357 0 6.125 2.346 6.125 5.308 0 .451-.37.817-.826.817H10.826a.821.821 0 0 1-.826-.817C10 18.346 12.768 16 16.125 16Zm0-7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z'
        fill='currentColor'
      />
      <path
        d='m24.733 9.345-.71-.711a10.962 10.962 0 0 0-7.408-3.216 10.97 10.97 0 0 0-8.149 3.216'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m25.878 10.542-.034.032a.954.954 0 0 1-.053.044l-.031.023a.992.992 0 0 1-.543.188l-3.988.162a.969.969 0 0 1-1.007-.928l.002-.15a1 1 0 0 1 .959-.979l2.98-.121.12-2.979a1 1 0 0 1 .978-.959l.09-.002a.97.97 0 0 1 .98.827l.01.151-.164 4.017a.996.996 0 0 1-.185.54l-.027.036a.778.778 0 0 1-.075.086l-.012.012Z'
        fill='currentColor'
      />
      <path
        d='m5.771 13.28-.26.97a10.961 10.961 0 0 0 .919 8.023 10.97 10.97 0 0 0 6.86 5.45'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m6.236 11.69.045.013a.7.7 0 0 1 .064.024l.036.015a.991.991 0 0 1 .434.377L8.95 15.49a.969.969 0 0 1-.3 1.336l-.132.074a1 1 0 0 1-1.327-.341l-1.595-2.52-2.64 1.385a1 1 0 0 1-1.319-.367l-.047-.078a.969.969 0 0 1 .226-1.26l.126-.085 3.561-1.868a.996.996 0 0 1 .56-.11l.045.006a.834.834 0 0 1 .112.022l.016.005Z'
        fill='currentColor'
      />
      <path
        d='m18.783 27.966.971-.26a10.962 10.962 0 0 0 6.489-4.807 10.97 10.97 0 0 0 1.29-8.665'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m17.174 28.36-.01-.047a.964.964 0 0 1-.013-.067l-.004-.039a.991.991 0 0 1 .11-.564l1.852-3.534a.969.969 0 0 1 1.308-.409l.13.077a1 1 0 0 1 .367 1.32l-1.385 2.64 2.52 1.594a1 1 0 0 1 .341 1.327l-.043.08a.969.969 0 0 1-1.206.434l-.136-.067-3.397-2.15a.996.996 0 0 1-.375-.43l-.018-.041a.856.856 0 0 1-.037-.109l-.004-.015Z'
        fill='currentColor'
      />
    </g>
  </svg>
);

export default PersonCycleIcon;
